import React, { useState } from 'react';
import { HrBlockContainer, HrDarkGrey, HrFlexContainer, HrFontBold, HrPrimary } from '@components/styles/hr-styles';
import styled from 'styled-components';

const TabButton = styled.button`
  background-color: ${(props) => (props.isActive ? '#FFF' : 'transparent')};
  border-radius: ${(props) => (props.isActive ? '8px 8px 0 0' : '0')};
  color: ${(props) => (props.isActive ? HrPrimary : HrDarkGrey)};
  border: none;
  padding: 8px 16px;
  font-weight: ${HrFontBold};
`;

export const GenericTabs = ({ tabs, initialActiveTab = 0 }) => {
  const [activeTab, setActiveTab] = useState(initialActiveTab);
  const handleTabClick = (index) => setActiveTab(index);
  const activeTabContent = tabs[activeTab].content;

  return (
    <HrBlockContainer>
      <HrFlexContainer gap='0px'>
        {tabs.map((tab, index) => (
          <TabButton
            key={tab.label}
            type='button'
            isActive={activeTab === index}
            onClick={() => handleTabClick(index)}
            className='p-8'
          >
            {tab.label}
          </TabButton>
        ))}
      </HrFlexContainer>
      <div>{activeTabContent}</div>
    </HrBlockContainer>
  );
};
